<template>
  <div class="relation">
    <div class="example">
      <vue-seamless-scroll :data="scopecodeOne" :class-option="defaultOption">
        <ul class="ul-scoll" style="width: 6760px">
          <li v-for="(item, index) in scopecodeOne" :key="index">
            <div class="c_logo">
              <div class="c_logo c_logo1_bg" :style="'background-position:0px ' + (index * -100 - 20) + 'px'"></div>
            </div>
            <div class="title">{{ item.commonAbbreviations }}</div>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
    <div class="example" style="margin-left: -130px">
      <vue-seamless-scroll :data="scopecodeTwo" :class-option="defaultOption">
        <ul class="ul-scoll" style="width: 6760px">
          <li v-for="(item, index) in scopecodeTwo" :key="index">
            <div class="c_logo">
              <div class="c_logo c_logo1_bg" :style="'background-position:0px ' + ((index + 26) * -100 - 20) + 'px'"></div>
            </div>
            <div class="title">{{ item.commonAbbreviations }}</div>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
    <div class="example">
      <vue-seamless-scroll :data="shippingAgentList" :class-option="defaultOption">
        <ul class="ul-scoll" style="width: 3640px">
          <li v-for="(item, index) in shippingAgentList" :key="index">
            <div class="c_logo">
              <div class="c_logo c_logo2_bg" :style="'background-position:0px ' + (index * -100 - 20) + 'px'"></div>
            </div>
            <div class="title">{{ getDisplayAgent(item.shippingAgent) }}</div>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import { scopecodeOne, scopecodeTwo, shippingAgentList } from '../home.js'
import { t } from '@/i18n'

export default {
  name: 'HomeRelation',
  data() {
    // 这里存放数据
    return {
      scopecodeOne,
      scopecodeTwo,
      shippingAgentList,
      listData: []
    }
  },
  // 监听属性 类似于data概念
  computed: {
    defaultOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods: {
    getDisplayAgent(agent) {
      const language = this.$store.getters.language
      const mapping = {
        '上海中外运': 'agent.sinotrans',
        '上海中联': 'agent.sinounion',
        '上海华港': 'agent.huagang',
        '上海外代': 'agent.penavico',
        '上海振华': 'agent.zhenhua',
        '上海民生': 'agent.minsheng',
        '上海航华': 'agent.hanghua',
        '上海顺德': 'agent.shunde',
        '上海鹏华': 'agent.penghua',
        '上海鹏海': 'agent.penghai',
        '上港联合': 'agent.sipg',
        '东方海外': 'agent.oocl',
        '新海': 'agent.xinhai',
        '锦诚': 'agent.jincheng'
      }
      const key = mapping[agent]
      return key ? t(key, language) : agent
    }
  }
}
</script>

<style scoped lang="scss">
.relation {
  margin: 40px 0 80px 0;
}
.example {
  width: 100%;
  height: 115px;
  margin-bottom: 20px;
  .ul-scoll {
    height: 120px;
    li {
      float: left;
      width: 239px;
      height: 115px;
      background: #ffffff;
      box-shadow: 0px 2px 4px 3px rgba(0, 0, 0, 0.02);
      border-radius: 12px;
      margin-left: 20px;
    }
  }
}

.c_logo {
  margin: 24px auto 8px;
}

.title {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
}

.c_logo1_bg {
  transform: scale(1.2);
  background: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/logos_chuan.png) no-repeat;
  width: 118px;
  height: 42px;
  background-position: 100px 100px;
}

.c_logo2_bg {
  transform: scale(1.2);
  background: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/logos_chuandai.png) no-repeat;
  width: 118px;
  height: 42px;
  background-position: 100px 100px;
}
</style>
